import { Table } from "@/components";
import {formatUserName, formatUserRoleToName, formatUserStatus, ImgSrc} from "@/utils";
import { Avatar, Stack, Typography } from "@mui/material";
import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetAcquiredUsersQuery } from "../../queries";
import { AffiliateAcquiredUsersTableProps } from "./affiliate-acquired-users-table.types";

const PER_PAGE = 5;

const AffiliateAcquiredUsersTable: FC<AffiliateAcquiredUsersTableProps> = ({
  userId,
}) => {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);

  const { acquiredUsers, fetchNextAcquiredUsers } = useGetAcquiredUsersQuery({
    userId,
    page,
    perPage: PER_PAGE,
  });

  const onPageChange = async (newPage: number) => {
    await fetchNextAcquiredUsers();
    setPage(newPage);
  };

  if (!acquiredUsers || acquiredUsers.meta.total === 0) {
    return null;
  }

  return (
    <Table
      page={page}
      rowsPerPage={PER_PAGE}
      rowsPerPageOptions={[]}
      headCells={["User", "Role", "Status"]}
      count={acquiredUsers.meta.total}
      onPageChange={onPageChange}
      bodyCells={acquiredUsers.data.map(
        ({ id, firstName, lastName, role, status, profileImage }) => [
          <Stack
            direction={"row"}
            spacing={2}
            sx={{ cursor: "pointer" }}
            alignItems={"center"}
            onClick={() =>
              navigate(`/users/${id}/show`, {
                state: { _scrollToTop: true },
              })
            }
          >
            <Avatar
              alt="avatar"
              src={ImgSrc(profileImage?.path ?? "")}
              sx={{ height: 32, width: 32 }}
            />
            <Typography component="span" variant="body2">
              {formatUserName(firstName, lastName, status)}
            </Typography>
          </Stack>,
          formatUserRoleToName(role),
          formatUserStatus(status),
        ],
      )}
    />
  );
};

export { AffiliateAcquiredUsersTable };
